import { useRouteLoaderData } from "react-router";
import { GlossaryTermCard, GlossaryTermGrid } from "@/components/glossary/GlossaryTermCard";
import type { LessonGlossaryTerm, LessonGlossaryTermsRenderer } from "@noiman/ui/lesson-glossary";

/** レッスンの頁の route の id (routes.ts の pages/courses/lessons/[lessonSlug].page.tsx) */
const LESSON_ROUTE_ID = "pages/courses/lessons/[lessonSlug].page";

/**
 * レッスンの下の「このレッスンに出てくる用語」を、用語集の頁と同じ札 (LearnCard) で並べる。
 * 欄はレッスンの左の欄 (1440 で約 540px) にも、スマホの 1 列にも入るので、絵が左・字が右の詰めた横長の札を
 * 1 列に積み、説明は切らずに全文出す。
 *
 * 難易度は、レッスンの頁の loader が欄に出す語の slug の分だけ DB から引いた値 (glossaryDifficulties)。
 * この欄は TextLessonPanel と ResumeArea (コーディングや SQL のレッスン) の 2 か所から出るので、
 * props で運ばず route の loader の値を読む。値の無い語と、ほかの頁から出た欄は棒を出さない。
 * 読んでいる途中で語を引く場所なので、札は新しいタブで開く (今までの動きのまま)
 */
function LessonGlossaryTermCards({ terms }: { terms: LessonGlossaryTerm[] }) {
  const difficulties = useRouteLoaderData<{ glossaryDifficulties?: Record<string, string> }>(LESSON_ROUTE_ID)
    ?.glossaryDifficulties;
  return (
    <GlossaryTermGrid list>
      {terms.map((t) => (
        <GlossaryTermCard
          key={t.slug}
          external
          layout="row"
          entry={{
            slug: t.slug,
            term: t.term,
            shortDescription: t.summary,
            category: t.category,
            difficulty: difficulties?.[t.slug],
          }}
        />
      ))}
    </GlossaryTermGrid>
  );
}

export const renderLessonGlossaryTerms: LessonGlossaryTermsRenderer = (terms) => <LessonGlossaryTermCards terms={terms} />;
